module.exports = __webpack_public_path__ + "static/media/institute-25-min.de85f722.webp";